import { styled } from '@mui/material/styles';
import { Box, Dialog, DialogContent } from '@mui/material';
import { useFieldArray, useForm } from 'react-hook-form';
import { FullscreenDialogHeader } from '../../dialogs/FullscreenDialogHeader';
import UpdateStatusForm from './UpdateStatusForm';
import { SyncedTripLeg } from '../../../data/models/reservation.model';
import { DialogAttempts } from '../../dialogs/DialogAttempts';

const PREFIX = 'WorkflowDialog';

const classes = {
  content: `${PREFIX}-content`,
  pages: `${PREFIX}-pages`,
};

interface UpdateStatusDialogProps {
  title: string;
  subTitle?: string;
  open: boolean;
  close: () => void;
  tripLeg: SyncedTripLeg;
}

const Root = styled(Dialog)(({ theme }) => ({
  [`& .${classes.content}`]: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    paddingLeft: 0,
    paddingRight: 0,
  },
  [`& .${classes.pages}`]: {
    display: 'flex',
    gap: theme.spacing(3),
    paddingLeft: theme.spacing(18),
    paddingRight: theme.spacing(18),
  },
}));

export default function UpdateStatusDialog({
  title,
  subTitle,
  open,
  close,
  tripLeg,
}: UpdateStatusDialogProps) {
  const formHook = useForm({
    mode: 'onTouched',
    // defaultValues: reservationUtils.getDefaults(
    //   passenger,
    //   null,
    //   transportationAttributes,
    // ),
  });

  const handleSubmit = () => {};

  const handleClose = () => {
    formHook.reset();
    close();
  };

  return (
    <Root fullScreen open={open} onClose={handleClose}>
      <FullscreenDialogHeader
        title={title}
        subTitle={subTitle}
        close={handleClose}
      />
      <DialogContent className={classes.content}>
        <Box className={classes.pages}>
          <UpdateStatusForm
            formHook={formHook}
            isSaving={false}
            isValid={false}
            tripLeg={tripLeg}
            submit={handleSubmit}
            close={close}
          />
        </Box>
      </DialogContent>
    </Root>
  );
}
